"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DoughnutOptions = /** @class */ (function () {
    function DoughnutOptions() {
        this.width = 500;
        this.height = 500;
        this.doughnutRatio = 0.4;
        this.data = Promise.resolve([]);
        this.iconUrl = undefined;
    }
    return DoughnutOptions;
}());
exports.default = DoughnutOptions;
